import { Injectable } from '@angular/core';

import { IOverAskMessages } from '../../../model/over-ask/over-ask';

@Injectable()
export abstract class OverAskMessagesProvider {
    messages: IOverAskMessages;
}
